import React from 'react';
export function ProductShowcase() {
  return <section className="w-full bg-cream-dark py-16 md:py-24 px-4 overflow-hidden" data-id="element-105">
      <div className="max-w-7xl mx-auto" data-id="element-106">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-brown-primary mb-12 font-serif" data-id="element-107">
          Visualiza tu nueva rutina
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-108">
          <div className="aspect-[4/5] rounded-lg overflow-hidden shadow-lg transform hover:scale-[1.02] transition-transform duration-500" data-id="element-109">
            <img src="https://cdn.magicpatterns.com/uploads/6TJWfrmLZBk8Ea1Dpqx5Kp/mokup-1.png" alt="Ambiente de spa en casa" className="w-full h-full object-cover" data-id="element-110" />
          </div>
          <div className="aspect-[4/5] rounded-lg overflow-hidden shadow-lg transform hover:scale-[1.02] transition-transform duration-500 md:-mt-8" data-id="element-111">
            <img src="https://cdn.magicpatterns.com/uploads/7AVKnA4fwHJWrePDV3uG4e/mockup-3.png" alt="Guía digital Piel de Vidrio" className="w-full h-full object-cover" data-id="element-112" />
          </div>
          <div className="aspect-[4/5] rounded-lg overflow-hidden shadow-lg transform hover:scale-[1.02] transition-transform duration-500" data-id="element-113">
            <img src="https://cdn.magicpatterns.com/uploads/24gLYDg2gNWLQsLB3V3Bzg/mockup-2.png" alt="Resultados de piel radiante" className="w-full h-full object-cover" data-id="element-114" />
          </div>
        </div>
      </div>
    </section>;
}